import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IconContainer = styled.span`
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.info.main};
`;

export const Interactions = styled.div``;
